import React from 'react';

import { ReactComponent as HelpIcon } from '../../../svg/help.svg'

import classes from './Info.module.scss';

const Info = props => {
    const infoClass = type => {
        switch (type) {
            case 'alert':
                return classes.InfoAlert;
            case 'small':
                return classes.InfoSmall;
            default:
                return classes.Info;
        }
    }

    const iconElement = <div className={classes.HelpIcon}><HelpIcon /></div>;

    return <div>
        <div className={infoClass(props.type)}>
            {props.withIcon ? iconElement : null}
            <div className={props.withIcon ? classes.InfoText : classes.NoIconInfoText}>
                {props.children}
            </div>
        </div>
    </div>
}

export default Info;